function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { getTmsInstance } from 'integration-web-core--socle/js/assets/commons/_tms.js';
import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
import SwiperSlider from 'integration-web-core--socle/js/assets/modules/_swiperSlider.class';
import Video from 'integration-web-core--socle/js/assets/modules/_video.class';
var ServicesPresentation = /*#__PURE__*/function (_lm$Composant) {
  function ServicesPresentation(id) {
    var _this;
    _classCallCheck(this, ServicesPresentation);
    _this = _callSuper(this, ServicesPresentation, [id]);
    _this.myComponent = document.querySelector('.js-oss-presentation');
    _this.mainTitle = _this.myComponent.querySelector('[data-cerberus="TITLE_h1"]').innerHTML.trim();
    _this.seoZone = _this.myComponent.querySelector('.js-zone-seo');
    _this.accordion();
    if (_this.seoZone) {
      _this.loadSeoZone();
    }
    var btnCta = _this.myComponent.querySelector('.js-openPopin');
    if (btnCta) {
      btnCta.addEventListener('click', function (event) {
        var buttonlabel = event.target.querySelector('span').innerHTML.trim();
        _this.sendTracking(_this.mainTitle, buttonlabel);
      });
    }
    var contextualizedLink = _this.myComponent.querySelector('.js-contextualized-link');
    if (contextualizedLink) {
      contextualizedLink.addEventListener('click', function () {
        var trackingObj = {
          'event_name': 'button.click',
          'event_data': {
            'button_name': 'make an appointment',
            'feature_name': 'services'
          }
        };
        getTmsInstance().pushEvent(contextualizedLink, 'cdl_event', trackingObj);
      });
    }
    var elemVideo = _this.myComponent.querySelector('.video-js');
    if (elemVideo) {
      try {
        new Video();
      } catch (error) {
        console.error("error ".concat(error));
      }
    }
    var multiLinkBtns = _this.myComponent.querySelectorAll('.js-multilink');
    if (multiLinkBtns) {
      var _iterator = _createForOfIteratorHelper(multiLinkBtns),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var multiLinkBtn = _step.value;
          multiLinkBtn.addEventListener('click', function (event) {
            var buttonlabel = event.target.querySelector('span').innerText;
            _this.sendTracking(_this.mainTitle, buttonlabel);
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    var pushCustomBtns = _this.myComponent.querySelectorAll('.js-push-custom-link');
    if (pushCustomBtns) {
      var _iterator2 = _createForOfIteratorHelper(pushCustomBtns),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var pushCustomBtn = _step2.value;
          pushCustomBtn.addEventListener('click', function (event) {
            var buttonlabel = event.target.querySelector('span').innerText;
            _this.sendTrackingPushCustom(buttonlabel);
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    // Generate slider
    var pushSlider = _this.myComponent.querySelector('.m-push-cutting-container');
    if (pushSlider) {
      try {
        new SwiperSlider('.m-push-cutting-container');
      } catch (error) {
        console.error("error ".concat(error));
      }
    }
    _this.changeStoreBtns = document.querySelectorAll('.js-choose-store');
    if (_this.changeStoreBtns && _this.changeStoreBtns.length > 0) {
      var _iterator3 = _createForOfIteratorHelper(_this.changeStoreBtns),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var changeStoreBtn = _step3.value;
          changeStoreBtn.addEventListener('click', function (event) {
            event.preventDefault();
            window.dispatchEvent(new CustomEvent('openStoreContextLayerInSearchMode'));
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    return _this;
  }
  _inherits(ServicesPresentation, _lm$Composant);
  return _createClass(ServicesPresentation, [{
    key: "chaptersManager",
    value: function chaptersManager() {
      var _this2 = this;
      if (this.btnMoreChapter) {
        this.btnMoreChapter.addEventListener('click', function () {
          _this2.loadMoreChapters();
        });
      }
      if (this.btnLessChapter) {
        this.btnLessChapter.addEventListener('click', function () {
          _this2.loadLessChapters();
        });
      }
    }
  }, {
    key: "loadMoreChapters",
    value: function loadMoreChapters() {
      this.seoChapters.classList.remove('is-blurred');
      this.btnLessChapter.classList.remove('kl-hidden');
      this.btnMoreChapter.classList.add('kl-hidden');
    }
  }, {
    key: "loadLessChapters",
    value: function loadLessChapters() {
      this.seoChapters.classList.add('is-blurred');
      this.btnMoreChapter.classList.remove('kl-hidden');
      this.btnLessChapter.classList.add('kl-hidden');
      this.myComponent.querySelector('.js-zone-seo').scrollIntoView();
    }
  }, {
    key: "accordion",
    value: function accordion() {
      this.myAccordions = this.myComponent.querySelectorAll('.js-accordion');
      if (this.myAccordions) {
        var _iterator4 = _createForOfIteratorHelper(this.myAccordions),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var myAccordion = _step4.value;
            try {
              new Accordion(myAccordion);
            } catch (error) {
              console.error("error ".concat(error));
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }, {
    key: "sendTracking",
    value: function sendTracking(buttonvalue, buttonlabel) {
      var trackingObj = {
        'event_name': 'button.click',
        'event_data': {
          'button_value': "".concat(buttonvalue),
          'button_type': 'service',
          'button_name': "".concat(buttonlabel)
        }
      };
      getTmsInstance().pushEvent(document, 'cdl_event', trackingObj);
    }
  }, {
    key: "sendTrackingPushCustom",
    value: function sendTrackingPushCustom(buttonlabel) {
      var trackingObj = {
        'event_name': 'button.click',
        'event_data': {
          'button_type': 'service',
          'feature_name': 'services',
          'button_name': "".concat(buttonlabel)
        }
      };
      getTmsInstance().pushEvent(document, 'cdl_event', trackingObj);
    }
  }, {
    key: "loadSeoZone",
    value: function loadSeoZone() {
      this.btnMoreChapter = this.seoZone.querySelector('.js-more-chapter');
      this.btnLessChapter = this.seoZone.querySelector('.js-less-chapter');
      this.seoChapters = this.seoZone.querySelector('.js-chapters');
      this.chaptersManager();
    }
  }]);
}(lm.Composant);
lm.DOMReady(function () {
  try {
    new ServicesPresentation('servicespresentation');
  } catch (error) {
    console.error("error ".concat(error));
  }
});
export default ServicesPresentation;